export const CERTIFICATE_OF_COMPLETION_ADDRESS = 'certificate-of-completion'
